import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { AdminMenu } from 'components';

class CtAdminMenu extends Component {
  constructor(props) {
    super(props);

    this.handleItemClick = this.handleItemClick.bind(this);
  }

  handleItemClick = (e, data) => {
    this.props.history.push(this.props.match.url + '/' + data.name);
  };

  render() {
    const { location, match } = this.props;
    const { handleItemClick } = this;

    let activeLink = 'basicconf';
    if (location.pathname && match.url && location.pathname !== match.url) {
      activeLink = location.pathname.replace(match.url + '/', '');
    }

    return <AdminMenu activeItem={activeLink} onClickItem={handleItemClick} />;
  }
}

CtAdminMenu.propTypes = {};
CtAdminMenu.defaultProps = {};

export default withRouter(CtAdminMenu);



// WEBPACK FOOTER //
// ./src/script/containers/admin/CtAdminMenu.js